/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateDmSettingsResponse
 */
export interface UpdateDmSettingsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDmSettingsResponse
     */
    success: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDmSettingsResponse
     */
    isMuted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDmSettingsResponse
     */
    isArchived?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDmSettingsResponse
     */
    isBlocked?: boolean;
}

/**
 * Check if a given object implements the UpdateDmSettingsResponse interface.
 */
export function instanceOfUpdateDmSettingsResponse(value: object): value is UpdateDmSettingsResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function UpdateDmSettingsResponseFromJSON(json: any): UpdateDmSettingsResponse {
    return UpdateDmSettingsResponseFromJSONTyped(json, false);
}

export function UpdateDmSettingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDmSettingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'isMuted': json['isMuted'] == null ? undefined : json['isMuted'],
        'isArchived': json['isArchived'] == null ? undefined : json['isArchived'],
        'isBlocked': json['isBlocked'] == null ? undefined : json['isBlocked'],
    };
}

export function UpdateDmSettingsResponseToJSON(json: any): UpdateDmSettingsResponse {
    return UpdateDmSettingsResponseToJSONTyped(json, false);
}

export function UpdateDmSettingsResponseToJSONTyped(value?: UpdateDmSettingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'isMuted': value['isMuted'],
        'isArchived': value['isArchived'],
        'isBlocked': value['isBlocked'],
    };
}

